<template>
  <label
    class="base-shadow bg-background-neutral-secondary flex min-w-60 flex-col rounded-2xl border-2 duration-200"
    :class="[
      checked
        ? 'border-background-positive-primary'
        : 'border-situational-lightgrey',
      isSingle ? 'w-full' : '',
    ]"
  >
    <div
      class="rounded-t-2xl px-4 py-3"
      :class="checked ? 'bg-background-positive-muted' : 'bg-transparent'"
    >
      <FreeRadio
        type="checkbox"
        class="justify-between"
        :name="name"
        :checked="checked"
        @change="emit('onSelect', props.productPackage)"
      >
        <template #text>
          <h3 class="text-text-neutral-primary text-lg font-semibold">
            {{ productPackage.title }}
          </h3>
        </template>
      </FreeRadio>
    </div>
    <ul class="list-inside space-y-2 px-4 py-4 text-sm font-medium">
      <li
        v-for="product in productPackage.products"
        :key="product.id"
        class="text-text-neutral-secondary flex items-center gap-2"
      >
        <CheckMarkIcon class="flex shrink-0" />
        {{ product.title }}
      </li>
    </ul>
    <!-- This will push the price to the bottom -->
    <div class="flex-grow"></div>
    <p class="mt-0 px-4 pb-4 font-bold">
      <span
        v-price="productPackage.price.amount"
        class="text-text-positive-primary"
      ></span>
      <span
        v-price="productPackage.price.initial_amount"
        class="text-text-neutral-quaternary ml-2 text-xs font-medium line-through"
      >
      </span>
    </p>
  </label>
</template>

<script setup lang="ts">
  import { FreeRadio } from 'freedom-shared';
  import type { Airflow } from '@aviata/platform-types';

  import CheckMarkIcon from '@/assets/images/green-check.svg?component';

  const props = defineProps<{
    name: string;
    checked?: boolean;
    productPackage: Airflow.Products.Package;
    isSingle: boolean;
  }>();

  const emit = defineEmits<{
    onSelect: [selectedPackage: Airflow.Products.Package];
  }>();
</script>
